import React from 'react'
import PropTypes from 'prop-types'
import { filterPostsByTopicSlug } from '../../lib'
import TopicSection from '../topic-section'

const SampleRegistriesView = ({ posts, subTopics }) => (
  <React.Fragment>
    {subTopics.map((childTopic, idx) => (
      <TopicSection
        key={'topic_section_' + childTopic.slug}
        topic={{ name: childTopic.name, slug: childTopic.slug }}
        showTopics={false}
        showAllButton={false}
        posts={filterPostsByTopicSlug(posts, childTopic.slug)}
      />
    ))}
  </React.Fragment>
)

SampleRegistriesView.propTypes = {
  posts: PropTypes.array,
  subTopics: PropTypes.array,
}

export default SampleRegistriesView
